define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MPastureGroundCoverDomain = void 0;
    class MPastureGroundCoverDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MPastureGroundCoverDomain.LessThan10Pc, value: "Less than 10%" },
                    { key: MPastureGroundCoverDomain._1030Pc, value: "10-30%" },
                    { key: MPastureGroundCoverDomain._3070Pc, value: "30-70%" },
                    { key: MPastureGroundCoverDomain.MoreThan70Pc, value: "More than 70%" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MPastureGroundCoverDomain.LessThan10Pc] = 0;
                this.KeyIndex[MPastureGroundCoverDomain._1030Pc] = 1;
                this.KeyIndex[MPastureGroundCoverDomain._3070Pc] = 2;
                this.KeyIndex[MPastureGroundCoverDomain.MoreThan70Pc] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Less than 10%"] = 0;
                this.ValueIndex["10-30%"] = 1;
                this.ValueIndex["30-70%"] = 2;
                this.ValueIndex["More than 70%"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MPastureGroundCoverDomain = MPastureGroundCoverDomain;
    Object.defineProperty(MPastureGroundCoverDomain, "LessThan10Pc", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MPastureGroundCoverDomain, "_1030Pc", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MPastureGroundCoverDomain, "_3070Pc", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MPastureGroundCoverDomain, "MoreThan70Pc", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MPastureGroundCoverDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
